import { useQuery } from '@tanstack/react-query';
import { getCandleData, CandleResponse } from '../../../api/metrics';

/**
 * Hook to fetch price data for overlay
 */
export function usePriceData(
  productId: string,
  granularityMins: number,
  startDate: Date,
  endDate: Date,
  enabled: boolean = true
) {
  return useQuery<CandleResponse, Error>({
    queryKey: ['priceData', productId, granularityMins, startDate.toISOString(), endDate.toISOString()],
    queryFn: async () => {
      // getCandleData expects startTime and endTime as separate parameters
      return await getCandleData(
        productId,
        granularityMins,
        startDate.toISOString(),
        endDate.toISOString()
      );
    },
    enabled: enabled && !!productId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 30 * 60 * 1000, // 30 minutes
    refetchOnWindowFocus: false,
  });
}
